import { LocalizationPipe, LocalizationService } from '@abp/ng.core';
import { CommonModule } from '@angular/common';
import { Component, DestroyRef, inject, input, output, signal } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import {
  createFormCanSaveSignal,
  dismissDirtyFormModal,
  isFieldInvalid,
  prepareBulkActionIds,
  ZendraLocalizationServices,
  ZnBulkActionResultService,
  ZnConfirmation,
} from '@zendra/shared';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { IModalContent } from 'projects/shared/src/lib/zn-modal-wrapper/interfaces/IModalContent';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { catchError, EMPTY, finalize } from 'rxjs';
import { StandPlanningOrchestratorService } from 'orchestrator';
import { CreateFirstCycleRotationInputDto } from 'projects/orchestrator/src/lib/proxy/orchestrator/dtos/stand/models';

@Component({
  selector: 'lib-action-first-cycle-rotation',
  imports: [LocalizationPipe, CommonModule, ReactiveFormsModule],
  templateUrl: './action-first-cycle-rotation.html',
})
export class ActionFirstCycleRotation implements IModalContent {
  private readonly formBuilder = inject(FormBuilder);
  private readonly activeModal = inject(NgbActiveModal);
  private readonly confirmationService = inject(ZnConfirmation);
  private readonly standService = inject(StandPlanningOrchestratorService);
  private readonly destroyRef = inject(DestroyRef);
  private readonly localizationService = inject(LocalizationService);
  private readonly bulkActionResultService = inject(ZnBulkActionResultService);

  selectedRecords = input<any[]>([]);
  selectedRecordIds = input<number[]>([]);
  completed = output<void>();

  loading = signal(false);
  saving = signal(false);

  localizationResource = ZendraLocalizationServices.LanguageService;
  form: FormGroup = this.formBuilder.group({
    Cycle: [null, [Validators.required, Validators.min(1), Validators.pattern(/^-?\d+$/)]],
    Rotation: [
      null,
      [Validators.required, Validators.min(1), Validators.pattern(/^-?\d+$/)],
    ],
  });

  canSave = createFormCanSaveSignal(this.form);

  fieldInvalid(field: string): boolean {
    return isFieldInvalid(this.form, field);
  }

  save() {
    const standIds = prepareBulkActionIds(this.form, this.saving(), this.selectedRecordIds());
    if (!standIds) {
      return;
    }

    this.saving.set(true);
    const request: CreateFirstCycleRotationInputDto = {
      standIds,
      cycle: this.form.get('Cycle').value,
      rotation: this.form.get('Rotation').value,
    };

    this.standService
      .createFirstCycleRotation(request)
      .pipe(
        catchError(error => {
          console.error(error);
          return EMPTY;
        }),
        takeUntilDestroyed(this.destroyRef),
        finalize(() => this.saving.set(false)),
      )
      .subscribe(response => {
        this.bulkActionResultService.handle(response, {
          selectedCount: standIds.length,
        });

        this.completed.emit();
        this.activeModal.close();
      });
  }

  confirm(): void {
    this.save();
  }

  dismiss(): void {
    dismissDirtyFormModal(
      this.form,
      this.saving(),
      this.confirmationService,
      this.activeModal,
    );
  }
}
